<template>
  <div class="content-wrapper">
    <vx-card>
      <div class="vx-row">
        <div class="vx-col w-1/3">
          <div class="mt-4">
            <vs-button
              size="large"
              :to="`/conferences/attendees` + suffixParams"
              >Attendees</vs-button
            >
          </div>
          <div class="mt-4">
            <vs-button size="large" :to="`/conferences/booths` + suffixParams"
              >Booths</vs-button
            >
          </div>

          <div class="mt-4">
            <vs-button size="large" :to="`/conferences/sessions` + suffixParams"
              >Sessions</vs-button
            >
          </div>

          <div class="mt-4">
            <vs-button size="large" :to="`/conferences/live` + suffixParams"
              >Live Videos</vs-button
            >
          </div>

          <div class="mt-4">
            <vs-button size="large" :to="`/conferences/speakers` + suffixParams"
              >Speakers</vs-button
            >
          </div>

          <div class="mt-4">
            <vs-button size="large" :to="`/conferences/sponsors` + suffixParams"
              >Sponsors</vs-button
            >
          </div>

          <div class="mt-4">
            <vs-button size="large" :to="`/conferences/auctions` + suffixParams"
              >Auctions</vs-button
            >
          </div>

          <div class="mt-4">
            <vs-button
              size="large"
              :to="`/conferences/engagements` + suffixParams"
              >Engagements</vs-button
            >
          </div>

          <div class="mt-4">
            <vs-button size="large" :to="`/conferences/filters` + suffixParams"
              >Filters</vs-button
            >
          </div>
        </div>
        <div class="vx-col w-1/3"></div>
        <div class="vx-col w-1/3"></div>
      </div>
    </vx-card>
  </div>
</template>
<script>
export default {
  data: () => ({
    suffixParams: "",
  }),
  mounted() {
    setTimeout(() => {
      this.suffixParams =
        "?s=" + this.$route.query.s + "&e=" + this.$route.query.e;
    }, 1000);
  },
};
</script>